import {AttachFile} from '@mui/icons-material';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyNewSingleListing from './EtsyNewSingleListing';

export const etsyNewSingleListing: FeatureObject = {
  type: 'feature',
  title: 'Product Upload with optional pdf generation',
  description:
    'Used for adding single new listing. Works for physical and digital products. Optional PDF generation is supported for digital files.',
  IconComponent: AttachFile,
  showFeatureFrontPage: true,
  path: '/etsyNewSingleListing',
  component: (user) => (
    <WithEtsyAccount
      featureName="Product Upload with optional pdf generation"
      helpTutorialEnum={HelpTutorialEnum.ETSY_PRODUCT_UPLOAD}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyNewSingleListing selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'digital', 'upload', 'pdf', 'single listing'],
};
